import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import {importRetry} from "./importRetry";
import { BrowserRouter as Router } from 'react-router-dom';
import AuthRoutes from './modules/auth/routes';
import { MainLayout } from 'modules/layout/containers';
import CommonManager from './helpers/common';
import DashboardRoutes from './modules/screens/dashboard/routes';
// import ReportingRoutes from './modules/screens/reporting/routes';
// import MessagingRoute from './modules/screens/messaging/routes';
// import SummaryRoute from './modules/screens/summary/routes';
import { Spinner } from './modules/theme';

const MessagingRoute = React.lazy(() => importRetry(() => import('./modules/screens/messaging/routes')));
const ReportingRoutes = React.lazy(() => importRetry(() => import('./modules/screens/reporting/routes')));
const SummaryRoute = React.lazy(() => importRetry(() => import('./modules/screens/summary/routes')));

const commonmanager = new CommonManager();
export class MainRoutes extends Component {
  renderRoutes() {
    return (
      <React.Fragment>
        <AuthRoutes />
        <DashboardRoutes />
        <Suspense fallback={<Spinner style={{ zIndex: -1 }} />}>
          <MessagingRoute />
          <ReportingRoutes />
          <SummaryRoute />
        </Suspense>
        
      </React.Fragment>
    );
  }
  render() {
    const basename = process.env.PUBLIC_URL || '/';
    // update timezone
    commonmanager.UpdateTimezone();
    return (
      <Router basename={basename}>
        <MainLayout>{this.renderRoutes()}</MainLayout>
      </Router>
    );
  }
}

MainRoutes.propTypes = {
  currentUser: PropTypes.object
};

MainRoutes.contextTypes = {
  __: PropTypes.func
};

export default MainRoutes;



// WEBPACK FOOTER //
// ./src/MainRoutes.js